import React from 'react';
import { faTire } from '@fortawesome/pro-regular-svg-icons/faTire';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function TireRegularIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faTire} {...props} />;
}
